import { useState, useCallback } from "react";

/**
 * Hook para manejar sessionStorage (datos que duran solo la sesión del navegador)
 *
 * @param {string} key - Clave para sessionStorage
 * @returns {Object} {value, setValue}
 *
 * @example
 * const {value, setValue} = useSessionStorage('mi-data');
 */
export const useSessionStorage = (key) => {
  const [value, setValue] = useState(() => {
    try {
      const item = sessionStorage.getItem(key);
      if (!item) return null;

      const parsedItem = JSON.parse(item);
      return parsedItem;
    } catch (error) {
      console.warn(`Error reading sessionStorage key "${key}":`, error);
      return null;
    }
  });

  const setStoredValue = useCallback(
    (newValue) => {
      try {
        if (newValue === null || newValue === undefined) {
          sessionStorage.removeItem(key);
          setValue(null);
          return;
        }

        sessionStorage.setItem(key, JSON.stringify(newValue));
        setValue(newValue);
      } catch (error) {
        console.error(`Error setting sessionStorage key "${key}":`, error);
      }
    },
    [key]
  );

  return { value, setValue: setStoredValue };
};
